<template>
  <div class="file-uploader">
    <file-dropzone
      :id="id"
      :options="options"
      :awss3="awss3"
      @vdropzone-file-added="fileAdded"
      @vdropzone-removed-file="fileRemoved"
      @vdropzone-processing="$emit('processing')"
      @vdropzone-queue-complete="$emit('complete')"
      @vdropzone-s3-upload-error="s3UploadError"
      @vdropzone-s3-upload-success="s3UploadSuccess"
      @vdropzone-success="fileUploadSuccess"
      @vdropzone-error="fileUploadError" />
  </div>
</template>

<script>
import FileDropzone from '@/components/FileDropzone'

export default {
  name: 'FileUploader',

  components: {
    FileDropzone
  },

  props: {
    name: {
      type: String
    },

    id: {
      type: String,
      required: true
    },

    bucket: {
      type: String,
      required: true
    }
  },

  data () {
    return { 
      options: {
        url: `${process.env.VUE_APP_API_URL}account/${this.$route.params.account}/files`,
        headers: {
          'Authorization': `Bearer ${this.$cookies.get('token')}`
        },
        method: 'put',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        withCredentials: true,
        // addRemoveLinks: true,
        dictCancelUpload: 'Cancel',
        dictCancelUploadConfirmation: 'Confirm Cancel',
        dictRemoveFile: '&#10005;'
      },
      awss3: {
        signingURL: `${process.env.VUE_APP_API_URL}account/${this.$route.params.account}/files`,
        headers: {
          'Authorization': `Bearer ${this.$cookies.get('token')}`
        },
        params: {
          bucket: 'fleetbeacon-records'
        },
        sendFileToServer: true,
        withCredentials: true
      },
    }
  },

  methods: {
    fileAdded (file) {
      this.$emit('file-added', file)
    },

    fileRemoved (file) {
      this.$emit('file-removed', file)
    },

    s3UploadSuccess (data) {
      console.log('S3 Upload Successful')
    },

    s3UploadError (error) {
      console.error('S3 Upload Error')
      console.error(error)
      this.$toasted.error(error)
    },

    fileUploadSuccess (file, response) {
      console.log('File Upload Successful')
      this.$emit('success', response)
    },

    fileUploadError (file, message, xhr) {
      console.error('File Upload Error')
      console.error(message)
      this.$emit('error', response)
      this.$toasted.error(message)
    }
  }
}
</script>

<style lang="postcss">
.file-uploader {
  .vue-dropzone.dropzone {
    @apply bg-gray-100 border border-gray-200 text-gray-500 rounded min-h-0;

    .dz-preview {
      @apply w-full bg-gray-700 rounded-md inline-flex items-center justify-center m-0 p-3 min-h-0 h-12 flex;
      
      &:not(:last-child) {
        @apply mb-2;
      }

      .dz-image {
        @apply h-10 w-10;
      }

      .dz-image > div {
      }

      .dz-image > img {
        @apply h-10 w-10;
      }

      .dz-details {
        @apply bg-transparent text-white text-left transition duration-200 ease-linear rounded flex flex-col-reverse justify-center items-start p-0 static leading-tight opacity-100;
      }

      .dz-filename {
        @apply text-sm font-bold text-left max-w-xs;

        span {
          @apply p-0;
        }
      }

      .dz-size {
        @apply m-0 text-xs opacity-50;

        span {
          @apply p-0;
        }
      }

      .dz-success-mark {
        @apply top-0 h-full flex items-center;
        
        svg {
          @apply w-8 h-8;
        }
      } 
      
      .dz-error-mark {
        @apply top-0 h-full flex items-center;

        svg {
          @apply w-8 h-8;
        }
      }
      
      .dz-remove {
        @apply absolute m-0 opacity-75 normal-case tracking-normal text-sm flex items-center justify-center rounded-full border-none bg-gray-900 bottom-auto right-0 mr-4 h-6 w-6 p-0;

        &:hover {
          @apply opacity-100 no-underline;
        }
      }
    }
  }
}
</style>